<script setup>
import { ref, computed } from 'vue'
import { useGlobalStore } from '@stores/global'
import MobileMenu from '@components/global/MobileMenu.vue'
import DesktopMenuItem from '@components/global/DesktopMenuItem.vue'

const global = useGlobalStore()

const links = computed(() => global.menuTree)

const socials = ref([
	{
		label: 'Twitter',
		icon: 'fab fa-x-twitter',
		href: 'https://x.com/snk_esports_hub',
	},
	{
		label: 'Instagram',
		icon: 'fab fa-instagram',
		href: 'https://instagram.com/snk_esports_hub',
	},
	{
		label: 'TikTok',
		icon: 'fab fa-tiktok',
		href: 'https://www.tiktok.com/@snk_esports_hub',
	},
])
</script>

<template>
	<header class="fixed left-0 top-0 z-10000 w-full border-b border-snk-light-900 bg-snk-light-500">
		<div class="container">
			<div class="relative flex items-center justify-between py-3">
				<router-link :to="{ name: 'index' }">
					<img src="https://cdn.snkesports.com/events/images/logos/snk-esports-blue.svg" alt="SNK Esports Logo" class="relative h-10" />
				</router-link>

				<!-- Desktop Navigation -->
				<div class="hidden items-center justify-end gap-2 lg:flex">
					<DesktopMenuItem v-for="(link, i) in links" :key="link.label + i" :item="link" :depth="0" />
				</div>

				<div class="flex gap-5">
					<a class="py-1 font-poppins text-sm font-bold uppercase transition-colors duration-200 hover:text-snk-blue-500" v-for="link in socials" :href="link.href" target="_blank"><i :class="['text-lg', link.icon]" /></a>
				</div>

				<!-- Mobile Menu Button -->
				<button @click="global.toggleMobile()" class="flex items-center justify-center p-2 text-snk-dark-300 lg:hidden" aria-label="Toggle mobile menu">
					<i class="fas fa-bars text-xl" v-if="!global.mobile"></i>
					<i class="fas fa-times text-xl" v-else></i>
				</button>
			</div>
		</div>
	</header>
	<Transition name="slide-out" :duration="550">
		<MobileMenu :items="links" />
	</Transition>
</template>

<style scoped>
@reference '../../../css/theme.css';

.router-link-exact-active {
	@apply text-snk-blue-500;
}
</style>
